import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import { MatCardModule } from '@angular/material/card';

import { AiCostBreakdown } from '../../core/admin/ai-cost.types';
import { IconComponent } from '../icon/icon';

/**
 * AI cost panel (Ops-only surface; N4).
 *
 * Shows what AI spend an application has incurred — a total (ZAR + USD), a
 * per-purpose breakdown (e.g. document checks vs full assessment), and the
 * individual costed calls. Lets a reviewer / the business see the cost of each
 * AI feature.
 *
 * Dumb component: the host fetches the breakdown and passes it in.
 */
@Component({
  selector: 'app-ai-cost-panel',
  imports: [DatePipe, DecimalPipe, MatCardModule, IconComponent],
  templateUrl: './ai-cost-panel.html',
  styleUrl: './ai-cost-panel.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiCostPanelComponent {
  /** The breakdown, or null while loading / when none exists. */
  readonly breakdown = input<AiCostBreakdown | null>(null);
  /** Whether the breakdown is being fetched. */
  readonly loading = input(false);

  protected readonly hasCalls = computed(() => (this.breakdown()?.count ?? 0) > 0);
}
